export const environment = {
    production: false,
    apiUrl: 'https://dev-oopsgateway.azurewebsites.net/api'
  };
  